import React from 'react'
import Collapse from "../../components/Collapse";

const Parts: React.FC = () => {
    return (
<React.Fragment>
<img src="https://static.igem.wiki/teams/5058/topoparts.svg"
alt=""
className="w-full h-[20%]"
/>
<div className="flex items-center justify-center w-full"><div
      tabIndex={0}
      className="bg-grape-light p-4  text-wrap  text-center h-30 w-max border-base-300 rounded-badge"
      >
     <p className="w-[40em]"> We have designed and built different parts for our project. Here we list and briefly describe the existing and new parts that we chose to work with. All of the new parts were submitted to the iGEM Parts Registry following the protocol. For more information about a part, please check the corresponding page.
      </p>
    </div> 
      </div>
<div>
<h4>
    <img src="https://static.igem.wiki/teams/5058/tabela1parts.svg"
alt=""
className="w-full h-[20%]"
/>
FLO1 - BBa_K2935073
  </h4>
<p>Flo1 is a cell wall glycoprotein crucial for cell flocculation in Saccharomyces cerevisiae. Also referred to as flocculin, due to its role in promoting cell-to-cell adhesion, Flo1 interacts with mannan, a structural carbohydrate present in fungal cell walls. This interaction facilitates cell aggregation and sedimentation in liquid media, simplifying the separation of the medium from the cell biomass.</p>

<h4>NLS-NucA - BBa_K3927015</h4>
<p>
NucA is a gene encoding an enzyme capable of degrading both single- and double-stranded nucleic acids. On its own, NucA demonstrates limited conductivity to nuclei; however, when combined with a nuclear localization signal, its nuclear targeting efficiency significantly improves. This property makes NucA highly relevant as a foundation for kill-switch mechanisms in biological circuits, thereby enhancing biosafety in synthetic biology applications.
</p>
yGFP - BBa_J434132
Yeast optimized green fluorescent protein (GFP), from iGEM 2024 Distribution Kit.
  <img src="https://static.igem.wiki/teams/5058/tabela2parts.svg  "
  className="w-full h-[20%]"
  alt=""
/>
<h4>ADH2p</h4>
<p>
The ADH2 promoter is a well-characterized and widely used regulatory element in <i>Saccharomyces cerevisiae</i> that controls the expression of the alcohol dehydrogenase 2 gene. Its activity is tightly regulated by glucose levels, exhibiting repression during high glucose conditions and strong induction during glucose depletion, making it a key component in metabolic and synthetic biology applications. Due to its glucose-repressible nature, the ADH2 promoter is frequently employed in metabolic engineering strategies to drive gene expression in the later stages of fermentation, allowing for temporal control.
</p>

<h4>HSEp</h4>
<p>
Heat shock element (HSE) promoters in <i>Saccharomyces cerevisiae</i> are regulatory sequences that respond to various stress conditions associated with elevated temperatures. These promoters contain conserved DNA motifs recognized by heat shock transcription factors (HSFs), which activate the expression of heat shock proteins (HSPs) to protect cells against damage. Due to their rapid and robust induction in response to stress, HSE-containing promoters are valuable tools in synthetic biology for driving the expression of genes under controlled temperature stress conditions. Our promoter uses the base of the CYC1 promoter sequence with regulation by two HSEs.
</p>

<h4>LacZ</h4>
<p>
The lacZ gene, which encodes the enzyme β-galactosidase, is a widely used reporter in synthetic biology for assessing promoter strength and gene expression in various organisms, including <i>Saccharomyces cerevisiae</i>. When fused to a promoter of interest, lacZ allows for a quantitative measurement of promoter activity through simple enzymatic assays. β-galactosidase catalyzes the hydrolysis of substrates like ONPG, which produces a quantifiable yellow product. This makes lacZ an effective and versatile tool for characterizing promoter efficiency, screening promoter libraries, and optimizing gene expression systems.
</p>

<h4>AID</h4>
<p>
The Auxin-Inducible Degron (AID) tag is a valuable tool within the degron system, used for the rapid and controlled degradation of proteins in yeast cells. As described by Morawska and Ulrich (2013), this technology enables the regulation of protein stability through the addition of the small molecule auxin, which induces the degradation of the tagged protein via the proteasome pathway. The system relies on the expression of a protein of interest fused to the AID tag, which, in the presence of auxin, is recognized by the plant-derived TIR1 receptor. This receptor is co-expressed in yeast cells and, when bound to auxin, targets the AID-tagged protein for degradation.
</p>

<h4>AID-6HA</h4>
<p>
AID tag added with a 6X-hemagglutinin marker, used for identification by immunological assays, as western blot.
</p>

<h4>AID-GFP</h4>
<p>
AID tag added with a Green fluorescent protein (GFP) marker, used for identification by immunological assays, as western blot, and fluorescence assays.
</p>

<h4>Tir1</h4>
<p>
The TIR1 gene encodes an F-box protein that plays a crucial role in the Auxin-Inducible Degron (AID) system. Originally derived from <i>Arabidopsis thaliana</i>, TIR1 functions as part of the SCF (Skp1-Cullin-F-box) E3 ubiquitin ligase complex, which is responsible for recognizing and targeting AID-tagged proteins for proteasomal degradation. In the presence of auxin, TIR1 binds to the AID tag, facilitating the ubiquitination and subsequent degradation of the tagged protein.
</p>

<h4>ADH2p-Tir1</h4>
<p>
Composite part that integrates the promoter ADH2p with the TIR1 gene, it shall be used to synthesize Tir1 protein during stationary phase of growth to be used on the degron system together with the target protein tagged with AID.
</p>

<h4>ADH2p-LacZ</h4>
<p>
Composite part that integrates the promoter ADH2p with the LACZ gene, it shall permit evaluating the promoter efficiency during cell growth.
</p>

<h4>HSEp-LacZ</h4>
<p>
Composite part that integrates the promoter HSEp with the LACZ gene, it shall permit evaluating the promoter efficiency by temperature increase stress.
</p>

<h4>HSEp-Flo1</h4>
<p>
Composite part that integrates the promoter HSEp with the LACZ gene, it shall be used to induce cell flocculation by temperature increase stress.
</p>

<h4>HSEp-NCL-NucA</h4>
<p>
Composite part that integrates the promoter HSEp with the NCL-NucA gene, it shall be used to induce cell death by temperature increase stress.
</p>

<h4>TEF1p</h4>
<p>
The TEF1 promoter is a commonly used regulatory sequence in <i>Saccharomyces cerevisiae</i> that drives high-level expression of target genes. It is derived from the TEF1 gene, which encodes Translation Elongation Factor 1-alpha (EF-1α), a protein involved in the elongation phase of protein synthesis. Due to its strong and constitutive activity, the TEF1 promoter is frequently used in synthetic biology and genetic engineering to ensure robust expression of genes across various growth conditions in yeast.
</p>

<h4>TEF1p-yGFP</h4>
<p>
Composite part that integrates the promoter TEF1p with the yGFP gene, it shall be used to measure cell population density by fluorescence.
</p>
<h4>HSEp-LacZ</h4>
<p>
Composite part that integrates the promoter HSEp with the LACZ gene, it shall permit evaluating the promoter efficiency by temperature increase stress.
</p>

<h4>HSEp-Flo1</h4>
<p>
Composite part that integrates the promoter HSEp with the LACZ gene, it shall be used to induce cell flocculation by temperature increase stress.
</p>

<h4>HSEp-NCL-NucA</h4>
<p>
Composite part that integrates the promoter HSEp with the NCL-NucA gene, it shall be used to induce cell death by temperature increase stress.
</p>

<h4>TEF1p</h4>
<p>
The TEF1 promoter is a commonly used regulatory sequence in <i>Saccharomyces cerevisiae</i> that drives high-level expression of target genes. It is derived from the TEF1 gene, which encodes Translation Elongation Factor 1-alpha (EF-1α), a protein involved in the elongation phase of protein synthesis. Due to its strong and constitutive activity, the TEF1 promoter is frequently used in synthetic biology and genetic engineering to ensure robust expression of genes across various growth conditions in yeast.
</p>

<h4>TEF1p-yGFP</h4>
<p>
Composite part that integrates the promoter TEF1p with the yGFP gene, it shall be used to measure cell population density by fluorescence.
</p>
<Collapse>
<Collapse.Title>
References
</Collapse.Title>
<Collapse.Content>
<p>Goossens, K., Willaert, R. Flocculation protein structure and cell–cell adhesion mechanism in Saccharomyces cerevisiae . Biotechnol Lett 32, 1571–1585 (2010). https://doi.org/10.1007/s10529-010-0352-3
Beier, D. R., & Young, E. T. (1982). Regulation of ADH2 expression in Saccharomyces cerevisiae by glucose and the ADR1 gene product. Proceedings of the National Academy of Sciences, 79(14), 4522-4526. 
Shuster, J. R. (1982). A high-level, glucose-repressible promoter from the Saccharomyces cerevisiae ADH2 gene. Gene, 20(1), 51-58. 
Slater, M R, and E A Craig. “Transcriptional regulation of an hsp70 heat shock gene in the yeast Saccharomyces cerevisiae.” Molecular and cellular biology vol. 7,5 (1987): 1906-16. doi:10.1128/mcb.7.5.1906-1916.1987
Morawska M, Ulrich HD. An expanded tool kit for the auxin-inducible degron system in budding yeast. Yeast. 2013 Sep;30(9):341-51. doi: 10.1002/yea.2967. Epub 2013 Jul 23. PMID: 23836714; PMCID: PMC4171812.</p>
</Collapse.Content>
</Collapse>
<p className="m-b-4"></p>
    </div>
 </React.Fragment>
)
}

export default Parts
